// @flow
import * as React from 'react';
import {
    getAllUpcomingAuctionsUrl,
    getAuctioneerDirectoryUrl,
    getAuctionResultsUrl,
    getTodayUrl,
} from '../../../utils/urls';
import DropDownMenu from '@liveauctioneers/caterwaul-components/lib/DropDownMenu/DropDownMenu';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faFire } from '@fortawesome/pro-regular-svg-icons/faFire';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import isEqual from 'react-fast-compare';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styles from './FindAuctions.module.scss';

type Props = {|
    parent: any,
    trackPastAuctionResultsClick: Function,
|};

const FindAuctions = (props: Props) => {
    const { parent, trackPastAuctionResultsClick } = props;

    const links = [
        <Link className={styles.link} key={0} route to={getAllUpcomingAuctionsUrl()}>
            <FormattedMessage id="auction_calendar" />
            <FontAwesomeIcon className={styles.calendar} icon={faCalendarAlt} />
        </Link>,
        <Link className={styles.link} key={1} route to="/find-auctions-near-me">
            <FormattedMessage id="auctions_near_me" />
        </Link>,
        <Link className={styles.link} key={2} route to={getTodayUrl()}>
            <FormattedMessage id="trending_auctions" />
            <FontAwesomeIcon className={styles.calendar} icon={faFire} />
        </Link>,
        <Link className={styles.link} key={3} route to={getAuctioneerDirectoryUrl()}>
            <FormattedMessage id="auction_house_directory" />
        </Link>,
        <Link className={styles.link} key={4} onClick={trackPastAuctionResultsClick} route to={getAuctionResultsUrl()}>
            <FormattedMessage id="past_auction_results" />
        </Link>,
    ];

    const title = <FormattedMessage id="find_auctions" />;

    return (
        <DropDownMenu
            dropdownClass={styles.aDropDown}
            links={links}
            parent={parent}
            placement="bottom"
            popoverClass={styles.popup}
            title={title}
            titleClass={styles['auction-title']}
        />
    );
};

export default React.memo<Props>(FindAuctions, isEqual);
